export default function getFieldConfigByPath(fieldConfigs, path) {
    return fieldConfigs.find(fc => fc.path === path);
}